import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { MatTooltip } from '@angular/material/tooltip';

import { SECTION_LABEL_CLASS } from '../ui/ui.classes';

/**
 * One named block of a details panel. Every section of every panel is announced the same way, so a
 * reader looking for the same fact twice finds it under the same heading both times.
 *
 * The container half of the pair {@link FactComponent} completes: a section names a group, a fact
 * names one value. A section holds arbitrary markup and lets it wrap; a fact holds a value and
 * truncates it. Both take their label already translated, so neither is the odd one out.
 */
@Component({
  selector: 'guarantees-panel-section',
  standalone: true,
  imports: [MatTooltip],
  // The section is the surrounding column's own flex item; a host box between them would
  // take the column's gap twice.
  host: { class: 'contents' },
  template: `
    <section class="flex flex-col gap-1.5">
      <span [class]="labelClass" [matTooltip]="hint()" [matTooltipDisabled]="!hint()">{{ label() }}</span>
      <ng-content />
    </section>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelSectionComponent {
  label = input.required<string>();
  hint = input<string>('');

  protected readonly labelClass = SECTION_LABEL_CLASS;
}
